import React, {useRef, useState} from 'react';
import {Button, Card, Form} from 'react-bootstrap';
import Select from 'react-select';
import {PfButton} from '@profabric/react-components';

export default function ModalAddPic(props) {
  const [file, setFile] = useState([
    {id: 1, file: null},
    {id: 2, file: null},
    {id: 3, file: null}
  ]);
  const [error, setError] = useState('');
  const [b64, setB64] = useState('');

  const handleValidation = () => {
    let errors = '';
    let formIsValid = true;

    if (
      file[0].file === null &&
      file[0].file === null &&
      file[0].file === null
    ) {
      formIsValid = false;
      errors = errors + 'กรุณาใส่รูปอย่างน้อย 1 รูป';
    }

    if (!formIsValid) setError(`Required: ${errors}`);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (handleValidation()) {
      setLoading(true);
      try {
        const result = await props.onUpload(file);
        setLoading(false);
      } catch (error) {}
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file); //ปัญหา
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const photoUpload = async (e, id) => {
    e.preventDefault();
    const _file = e.target.files[0];
    if (_file) {
      let base64 = await convertToBase64(_file);
      setB64(base64);
      const temp = file.map((e) => {
        if (e.id === id) return {...e, file: _file};
        else return e;
      });
      console.log(temp);
      setFile(temp);
    }
  };

  const [isLoading, setLoading] = useState(false);
  return (
    <div>
      <Form>
        <div className="row">
          <Form.Group className="mb-3 col-md-12">
            <div className="custom-file">
              <input
                type="file"
                onChange={(e) => {
                  photoUpload(e, 1);
                }}
                className="custom-file-input"
                accept=".jpef, .png, .jpg"
                id="customFile"
              />
              <label className="custom-file-label" htmlFor="customFile">
                {file[0].file
                  ? file[0].file.name
                  : 'รูปที่ 1 | ขนาดภาพไม่เกิน 4MB'}
              </label>
            </div>
          </Form.Group>
          <Form.Group className="mb-3 col-md-12">
            <div className="custom-file">
              <input
                type="file"
                onChange={(e) => {
                  photoUpload(e, 2);
                }}
                className="custom-file-input"
                accept=".jpef, .png, .jpg"
                id="customFile"
              />
              <label className="custom-file-label" htmlFor="customFile">
                {file[1].file
                  ? file[1].file.name
                  : 'รูปที่ 2 | ขนาดภาพไม่เกิน 4MB'}
              </label>
            </div>
          </Form.Group>
          <Form.Group className="mb-3 col-md-12">
            <div className="custom-file">
              <input
                type="file"
                onChange={(e) => {
                  photoUpload(e, 3);
                }}
                className="custom-file-input"
                accept=".jpef, .png, .jpg"
                id="customFile"
              />
              <label className="custom-file-label" htmlFor="customFile">
                {file[2].file
                  ? file[2].file.name
                  : 'รูปที่ 3 | ขนาดภาพไม่เกิน 4MB'}
              </label>
            </div>
          </Form.Group>
          <Form.Group className="mb-3 col-md-12">
            <Card className="col-12">
              <Card.Body>
                <div
                  className="container"
                  style={{
                    height: '28vh',
                    width: '100%',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center top',
                    backgroundImage:
                      b64 === ''
                        ? 'url("https://api-passport.advanceagro.net/img/car_temp.png")'
                        : ''
                  }}
                >
                  <img
                    className="rounded mx-auto d-block"
                    style={{
                      maxHeight: '100%',
                      maxWidth: '100%'
                    }}
                    src={b64 !== '' ? b64 : ''}
                  ></img>
                </div>
              </Card.Body>
            </Card>
          </Form.Group>
        </div>
      </Form>
      <p className="text-danger">{error}</p>
      <PfButton
        theme="success"
        block
        loading={isLoading}
        type="button"
        onClick={handleSubmit}
      >
        ท่านยืนยันในการอัพโหลด
      </PfButton>
    </div>
  );
}
